export default __webpack_public_path__ + "static/media/sauced_blueberry_gelato.4682835a.png";